import { render, staticRenderFns } from "./Scraper.vue?vue&type=template&id=72b1567a&"
import script from "./Scraper.vue?vue&type=script&lang=js&"
export * from "./Scraper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports